<!-- OverviewAll -->
<template>
  <div class="kanban" id="kanban">
    <div class="tit">
      <img src="@/assets/imgs/tit.png" style="width: 100%;">
      <img class="txt" src="@/assets/imgs/txt.png">
      <div class="my-timer">
        {{timerYMD}}
        <span>{{fullscreen}}</span>
        {{timerHMS}}
        <img src="@/assets/imgs/xx.png" v-if="fullscreen" @click="handleFullScreen">
        <img src="@/assets/imgs/ff.png" v-else @click="handleFullScreen">
      </div>
    </div>
    <div class="center">
      <div class="tul">
        <div class="tli">
          <img src="@/assets/imgs/1.png">
          <div class="txt">
            <div class="t">总站点数</div>
            <div class="b">Cooperative site</div>
          </div>
          <div class="num"><span>286 </span>个</div>
        </div>
        <div class="tli">
          <img src="@/assets/imgs/2.png">
          <div class="txt">
            <div class="t">配电房总量</div>
            <div class="b">distribution room</div>
          </div>
          <div class="num"><span>3286 </span>个</div>
        </div>
        <div class="tli">
          <img src="@/assets/imgs/3.png">
          <div class="txt">
            <div class="t">实时负荷</div>
            <div class="b">Real-time load</div>
          </div>
          <div class="num"><span>2866.6 </span>kW</div>
        </div>
        <div class="tli">
          <img src="@/assets/imgs/4.png">
          <div class="txt">
            <div class="t">负荷总数</div>
            <div class="b">Total load</div>
          </div>
          <div class="num"><span>2866.6 </span>万 kW</div>
        </div>
        <div class="tli">
          <img src="@/assets/imgs/5.png">
          <div class="txt">
            <div class="t">安全运行天数</div>
            <div class="b">SAFE OPERATION</div>
          </div>
          <div class="num"><span>36 </span>天</div>
        </div>
      </div>
      <div class="one">
        <div class="box">
          <div class="stit">
            <img class="icon" src="@/assets/imgs/fenlei.png">
            <span>站点用电量排行</span>
          </div>
          <div class="box_ul">
            <div class="box_li">
              <img src="@/assets/imgs/11.png">
              <div class="col">
                <div class="top">
                  <div class="txt">福州船政局</div>
                  <div class="num">2000.0 <span>kWh</span></div>
                </div>
                <div class="bon"><span></span></div>
              </div>
            </div>
            <div class="box_li">
              <img src="@/assets/imgs/22.png">
              <div class="col">
                <div class="top">
                  <div class="txt">浙江省工业园</div>
                  <div class="num">2000.0 <span>kWh</span></div>
                </div>
                <div class="bon"><span style="width: 90%;"></span></div>
              </div>
            </div>
            <div class="box_li">
              <img src="@/assets/imgs/33.png">
              <div class="col">
                <div class="top">
                  <div class="txt">玉阳办事处</div>
                  <div class="num">2000.0 <span>kWh</span></div>
                </div>
                <div class="bon"><span style="width: 70%;"></span></div>
              </div>
            </div>
            <div class="box_li">
              <img src="@/assets/imgs/44.png">
              <div class="col">
                <div class="top">
                  <div class="txt">山西省电力机车厂</div>
                  <div class="num">2000.0 <span>kWh</span></div>
                </div>
                <div class="bon"><span style="width: 40%;"></span></div>
              </div>
            </div>
            <div class="box_li">
              <img src="@/assets/imgs/55.png">
              <div class="col">
                <div class="top">
                  <div class="txt">景德镇国际商业中心</div>
                  <div class="num">2000.0 <span>kWh</span></div>
                </div>
                <div class="bon"><span style="width: 20%;"></span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="medil" style="flex: 1;">
          <div class="uploadfile-showImg" @mousewheel="bbimg(this)">
            <!-- <img :src="imgUrl" alt="" /> -->
            <div class="imgclass" :style="test" @mousedown="imgMove">
              <img src="@/assets/imgs/map.webp" alt="">
              <el-tooltip class="item" effect="dark" content="黑龙江" placement="top-start">
                <img class="int" @click="bbb" style="left: 67%; top: 21%;" src="@/assets/imgs/int.png" alt="">
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="北京" placement="top-start">
                <img class="int" @click="bbb" style="    left: 58%;  top: 35%;" src="@/assets/imgs/int.png" alt="">
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="上海" placement="top-start">
                <img class="int" @click="bbb" style=" left: 64%; top: 61%;" src="@/assets/imgs/int.png" alt="">
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="湖南" placement="top-start">
                <img class="int" @click="bbb" style="    left: 40%; top: 54%;  " src="@/assets/imgs/int.png" alt="">
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="西藏" placement="top-start">
                <img class="int" @click="bbb" style="    left: 25%;  top: 39%;" src="@/assets/imgs/int.png" alt="">
              </el-tooltip>
            </div>


          </div>
        </div>
        <div class="box">
          <div class="stit">
            <img class="icon" src="@/assets/imgs/fenlei.png">
            <span>告警类型</span>
          </div>
          <div class="box_echart" style="position: relative;">
            <vchart ref='vchartPie3' style="width: 100%;height: 2.77rem;"></vchart>
            <div class="tt">
              <span>367</span>
              <span>367</span>
              <span>367</span>
            </div>
          </div>
        </div>
      </div>

      <div class="tow" :style="{'height':heights+'px'}">
        <div class="box">
          <div class="stit">
            <img class="icon" src="@/assets/imgs/fenlei.png">
            <span>工单分类</span>
          </div>
          <div class="box_echart" style="position: relative;">
            <span class="spaned">
              <vchart class="vcharted" ref='vchartPie' style="width: 100%;height: 200px;"></vchart>
            </span>
          </div>
        </div>
        <div class="medioed">
          <div class="stit">
            <img class="icon" src="@/assets/imgs/fenlei.png">
            <span>工单最新事件</span>
          </div>
          <div class="ttable">
            <table class="table" style="width: 100%;" border>
              <thead>
                <tr class="tr">
                  <td scope="col" align="center" style="width:60px">序号</td>
                  <td scope="col">告警单位</td>
                  <td scope="col">工单标题</td>
                  <td scope="col" align="center">工单类型</td>
                  <td scope="col" align="center">工单状态</td>
                  <td scope="col" align="center">工单发起时间</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="i in 9" :key="i" class="tbody">
                  <td scope="row" align="center">{{i}}</td>
                  <td scope="row">山西省电力机车</td>
                  <td scope="row">配电房</td>
                  <td scope="row" align="center">抢修</td>
                  <td scope="row" align="center">处理中</td>
                  <td scope="row" align="center">2024/04/02 12:00</td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>


        <div class="box">
          <div class="stit">
            <img class="icon" src="@/assets/imgs/fenlei.png">
            <span>工单状态</span>
          </div>
          <div class="box_echart" style="position: relative;">
            <span class="spaned">
              <vchart class="vcharted" ref='vchartPie2' style="width: 100%;height: 200px;"></vchart>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- <img src="@/assets/kanban.png" style="width: 100%;"> -->

  </div>
</template>

<script>
  import centerMap from '@/page/projectDingZhi/Ubiquitous/centerMap.vue';
  import vchart from '@/components/module/chart/vchart.vue';

  export default {
    components: {
      vchart,
      centerMap
    },
    data () {
      return {
        imgUrl: 'https://img1.baidu.com/it/u=3955310150,3274562539&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1702054800&t=89b775b8e5cf0ff132c2d7346ecf130e',
        deg: 0,
        test: '',
        zoomInShow: false,
        params: {
          zoom: 1,
          left: 0,
          top: 0,
          currentX: 0,
          currentY: 0,
          flag: false,
        },
        heights: document.getElementById('app').clientHeight-590,//屏幕高度 - 导航栏高度
        fullscreen: false,
        roundOption2: {
          title: {
            text: '2326',
            subtext: '工单总数',
            left: '26%',
            top: '40%',
            textAlign: 'center',
            subtextStyle: {
              color: '#ccc',
              fontSize: 12,
              lineHeight: 0,
            },
            textStyle: {                  // 图例的公用文本样式。
              fontSize: 20,
              color: '#fff',
            }
          },
          legend: {
            icon: "rect", //  这个字段控制形状  类型包括 circle， ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 12, // 设置宽度
            itemHeight: 12, // 设置高度 
            orient: 'vertical',
            right: '6%',
            top: 'center',
            formatter: function(name) {
              return name+`    367`;
            },
            textStyle: {                      // 图例的公用文本样式。
              fontSize: 16,
              color: '#fff'
            }
          },

          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c}(台)  ({d}%)'
          },
          series: [
            {
              type: 'pie',
              label: {
                show: false,
              },
              data: [
                {
                  value: 10,
                  name: '已处理'
                },
                {
                  value: 20,
                  name: '处理中'
                },{
                  value: 20,
                  name: '待处理'
                },
              ],
              color: ["#37FFC9","#0084FF",'#FFB914'],
              radius: ['50%','60%'],
              center: ['27%','50%'],
            }
          ]
        },

        roundOption: {
          title: {
            text: '2326',
            subtext: '工单总数',
            left: '26%',
            top: '40%',
            textAlign: 'center',
            subtextStyle: {
              color: '#ccc',
              fontSize: 12,
              lineHeight: 0,
            },
            textStyle: {                  // 图例的公用文本样式。
              fontSize: 20,
              color: '#fff',
            }
          },
          legend: {
            icon: "rect", //  这个字段控制形状  类型包括 circle， ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 12, // 设置宽度
            itemHeight: 12, // 设置高度 
            orient: 'vertical',
            right: '6%',
            top: 'center',
            formatter: function(name) {
              return name+`    367`;
            },
            textStyle: {                      // 图例的公用文本样式。
              fontSize: 16,
              color: '#fff'
            }
          },

          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c}(台)  ({d}%)'
          },
          series: [
            {
              type: 'pie',
              label: {
                show: false,
              },
              data: [
                {
                  value: 10,
                  name: '巡检'
                },
                {
                  value: 20,
                  name: '检修'
                },{
                  value: 20,
                  name: '抢修'
                },
              ],
              color: ["#37FFC9","#0084FF",'#FFB914'],
              radius: ['50%','60%'],
              center: ['27%','50%'],
            }
          ]
        },
        fangFlag: false,
        timerNull: null,
        timerYMD: "",
        timerWeek: "",
        timerHMS: "",
        newsrc: "./demo2.html",
        roundOption3: {
          title: {
            text: '2326',
            subtext: '告警总数',
            left: '48%',
            top: '38%',
            textAlign: 'center',
            subtextStyle: {
              color: '#ccc',
              fontSize: 12,
              lineHeight: 0,
            },
            textStyle: {                  // 图例的公用文本样式。
              fontSize: 20,
              color: '#fff',
            }
          },
          legend: {
            icon: "rect", //  这个字段控制形状  类型包括 circle， ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 12, // 设置宽度
            itemHeight: 12, // 设置高度   
            bottom: '1',
            formatter: function(name) {
              return name;
            },
            textStyle: {                      // 图例的公用文本样式。
              fontSize: 16,
              color: '#fff'
            }
          },

          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c}(台)  ({d}%)'
          },
          series: [
            {
              type: 'pie',
              label: {
                show: false,
              },
              data: [
                {
                  value: 10,
                  name: '待处理'
                },
                {
                  value: 20,
                  name: '处理中'
                },{
                  value: 20,
                  name: '已处理'
                },
              ],
              color: ["#37FFC9","#0084FF",'#FFB914'],
              radius: ['50%','60%'],
              center: ['50%','45%'],
            }
          ]
        },

      };
    },

    mounted () {
      setFz();
      //  屏幕的宽度改变之后 
      window.onresize=function() {
        console.log(123);
        setFz();
      }
      function setFz () {
        /* 
        1 获取到当前的屏幕的宽度  =  要适配的屏幕的宽度
        2 计算html字体的大小   fontsize=基础值 * 要适配的屏幕的宽度 /  设计稿的宽度
        3 打开页面 直接调用该方法  屏幕的宽度改变之后 再调用一次这个方法 就可以动态改变html的字体
         */

        // 当前屏幕的宽度
        var screenWidth=document.querySelector("html").offsetWidth;
        // 基础值
        var baseVal=100;
        // 设计稿的宽度
        var pageWidth=1440;
        // 字体大小
        var fz=baseVal*screenWidth/pageWidth;

        document.querySelector("html").style.fontSize=fz+"px";

      }

      this.$refs.vchartPie.setData(this.roundOption);
      this.$refs.vchartPie2.setData(this.roundOption2);
      this.$refs.vchartPie3.setData(this.roundOption3);

      var _that=this
      this.timerNull=setInterval(() => {
        // 获取当前日期
        const date=new Date();

        // 获取年份(4位,如2022)
        const year=date.getFullYear();

        // 获取月份(0-11,所以获取月份要加1)
        const month=date.getMonth()+1;

        // 获取日期
        const day=date.getDate();

        // 获取周几(0-6,0表示周日)
        const week=date.getDay();

        // 24小时制时间
        const hours=date.getHours();

        // 分钟
        const minutes=date.getMinutes();

        // 秒
        const seconds=date.getSeconds();
        _that.timerYMD=year+'年'+month+'月'+day+'日'
        _that.timerWeek='星期'+['日','一','二','三','四','五','六'][week]
        _that.timerHMS=(hours>10? hours:'0'+hours)+':'+(minutes>10? minutes:'0'+minutes)+':'+(seconds>10? seconds:'0'+seconds)
      },1000)




    },

    methods: {
      // 鼠标滚轮滚动实现图片放大缩小 
      bbimg (ev) {
        let e=ev||window.event
        this.params.zoom+=e.wheelDelta/1200
        if(this.params.zoom>=0.2) {
          this.test=`transform:scale(${this.params.zoom}) rotateZ(${this.deg}deg);`
        } else {
          this.params.zoom=0.2
          this.test=`transform:scale(${this.params.zoom}) rotateZ(${this.deg}deg);`
          return false
        }
      },
      // 实现图片拖拽
      imgMove (e) {
        let oImg=e.target
        let disX=e.clientX-oImg.offsetLeft
        let disY=e.clientY-oImg.offsetTop
        document.onmousemove=(e) => {
          e.preventDefault()
          let left=e.clientX-disX
          let top=e.clientY-disY
          this.test=this.test+`left: ${left}px;top: ${top}px;`
        }
        document.onmouseup=(e) => {
          document.onmousemove=null
          document.onmouseup=null
        }
      },
      // 旋转
      rotate () {
        this.deg+=90
        if(this.deg>=360) {
          this.deg=0
        }
        this.test=`transform: rotateZ(${this.deg}deg)`
      },
      // 还原
      imgOut () {
        this.deg=0
        this.params={
          zoom: 1,
          left: 0,
          top: 0,
          currentX: 0,
          currentY: 0,
          flag: false,
        }
        this.test=`transform: rotateZ(0deg)`
      },

      handleFullScreen () {
        // 此处可根据获取节点进行区域全屏事件
        let element=document.getElementsByClassName('kanban')[0];
        if(this.fullscreen) {
          if(document.exitFullscreen) {
            document.exitFullscreen();
          } else if(document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if(document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if(document.msExitFullscreen) {
            document.msExitFullscreen();
          }

        } else {
          if(element.requestFullscreen) {
            element.requestFullscreen();
          } else if(element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if(element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if(element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
          }
        }
        this.fullscreen=!this.fullscreen;
        setTimeout(() => {
          this.heights=document.getElementById('app').clientHeight-590;//屏幕高度 - 导航栏高度
          this.$refs.vchartPie.setData(this.roundOption);
        },100);
      },
      bbb () {
        this.$router.push('/usePowerUnit')
      }
    }
  };
</script>

<style lang="scss" scoped>
  #kanban {
    width: 100%;
    position: fixed;
    top: 0;
    margin: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100% !important;
    z-index: 10;
  }

  .ttable {
    overflow-y: scroll;
    height: calc(100% - 29px);
  }

  .ttable::-webkit-scrollbar {
    display: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  .spaned {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .uploadfile-showImg {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 20;
    margin: 0 auto;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .setting_box {
    width: 100%;
    line-height: 30px;
    font-size: 16px;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    bottom: 5%;
    z-index: 999;
    display: flex;
    align-content: center;
    justify-content: center;
  }

  .img-footer {
    display: flex;
    align-content: center;
    justify-content: center;
  }

  .img-footer div {
    background-color: #2696ee;
    padding: 10px 20px;
    color: #fff;
    margin: 0 10px;
    cursor: pointer;
    border-radius: 10px;
  }

  .imgclass {
    max-width: 95vw;
    max-height: 90vh;
    position: relative;
    z-index: 22;
    margin-top: 40px;
    cursor: move;

  }

  .vcharted {
    width: 100%;
    min-height: 100px;
  }

  .kanban {
    /* background-color: #010203; */
    background: url(../../assets/imgs/bg22.png) no-repeat;
    background-size: 100% 100%;
    color: #fff;

    .tt {
      position: absolute;
      bottom: 0.3rem;
      left: 1.4rem;
      width: 100%;
      left: 0;
      display: flex;
      right: 0;
      justify-content: space-around;
      padding: 0 .4rem;
      box-sizing: border-box;
    }

    .tr {

      box-shadow: #010203;
      height: .33rem;
    }

    .tr td {
      color: #CCC;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: .13rem;
      border-bottom: 1px solid #082949;
    }

    tbody {

      tr:nth-child(even) {
        background-color: #0a2239;
      }
    }

    .tbody td {
      opacity: 1;
      height: .32rem;
      color: #FFF;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: .13rem;

    }

    .box_echart {
      .txt {
        position: absolute;
        top: .9rem;
        left: .6rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 999;
      }
    }

    .center {
      padding: 0 .24rem;

      .tow {
        display: flex;
        justify-content: space-between;
        margin-top: .12rem;
        min-height: 2rem;
        margin-bottom: .24rem;

        .medioed {
          flex: 1;
          box-sizing: border-box;
          margin: 0 .12rem;
          box-sizing: border-box;
          border-radius: .04rem;
          background: url(../../assets/imgs/box.png) no-repeat;
          background-size: 100% 100%;
          height: 100%;
          overflow: hidden;

          .stit {
            background: url(../../assets/imgs/ctit.png) no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            width: 100%;
            height: .24rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            padding-bottom: .07rem;

            span {
              font-size: .16rem;
            }

            .icon {
              margin-right: .08rem;
            }
          }
        }

        .box {
          width: 3.39rem;
          border-radius: .04rem;
          /* background: linear-gradient(180deg, #1C406000 0%, #1C406099 100%); */
          background: url(../../assets/imgs/box.png) no-repeat;
          background-size: 100% 100%;

          .stit {
            background: url(../../assets/imgs/xtit.png) no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            width: 100%;
            height: .24rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            padding-bottom: .07rem;

            span {
              font-size: .16rem;
            }

            .icon {
              margin-right: .08rem;
            }
          }
        }
      }

      .one {
        display: flex;
        justify-content: space-between;
        margin-top: .24rem;

        .medil {
          flex: 1;
          overflow: hidden;
          height: 3.37rem;
          position: relative;
          margin: 0 .12rem;

          .int {
            position: absolute;
            width: 53px;
            cursor: pointer;
            height: 45px;
            object-fit: cover;
          }

          .img {
            width: 7rem;
            position: absolute;
            left: 50%;
            top: 55%;
            transform: translate(-50%, -50%);

          }
        }

        .box {
          width: 3.39rem;
          height: 3.37rem;
          border-radius: .04rem;
          /* background: linear-gradient(180deg, #1C406000 0%, #1C406099 100%); */
          background: url(../../assets/imgs/box2.png) no-repeat;
          background-size: 100% 100%;

          .box_ul {
            padding-left: .08rem;

            .box_li:nth-child(1) {
              margin-top: .22rem;
            }

            .box_li {
              display: flex;
              align-items: center;
              margin-top: .32rem;

              .bon {
                border-radius: 3px;
                background: #1383EB33;
                width: 2.91rem;
                height: .06rem;
                overflow: hidden;

                span {
                  height: 100%;
                  width: 50%;
                  display: block;
                  border-radius: 3px;
                  background: linear-gradient(89deg, #1383EB 0%, #13D5EB 100%);
                }
              }

              .top {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 2.9rem;

                .txt {
                  font-family: Microsoft YaHei;
                  font-weight: regular;
                  font-size: .14rem;
                }

                .num {
                  color: #13D5EB;
                  font-family: Microsoft YaHei;
                  font-weight: bold;
                  font-size: .16rem;

                  span {
                    color: #FFFFFF99;
                    font-family: Microsoft YaHei;
                    font-weight: regular;
                    font-size: .12rem;
                    font-weight: normal;

                  }
                }
              }

              img {
                margin-right: .08rem;
              }
            }
          }

          .stit {
            background: url(../../assets/imgs/xtit.png) no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            width: 100%;
            height: .24rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            padding-bottom: .07rem;

            span {
              font-size: .16rem;
            }

            .icon {
              margin-right: .08rem;
            }
          }
        }
      }
    }

    .tul {
      display: flex;
      justify-content: space-between;
      margin-top: .34rem;

      .tli {
        display: flex;
        font-family: Microsoft YaHei;
        font-weight: regular;

        >img {
          width: .32rem;
          height: .32rem;
          object-fit: cover;
        }

        .num {
          font-size: .14rem;
          margin-left: .08rem;

          span {
            opacity: 1;
            font-family: D-DIN;
            font-weight: bold;
            font-size: .24rem;
            border-radius: 2px;
            background: linear-gradient(180deg, #1D364C19 5%, #1D4366 99%);
            margin-right: .04rem;
            text-align: center;
            padding-left: .06rem;
          }
        }

        .t {
          opacity: 1;
          font-weight: bold;
          font-size: .16rem;
        }

        .b {
          color: #CCC;
          font-size: .12rem;
        }

        img {
          margin-right: .08rem;
        }
      }
    }

    .tit {
      position: relative;

      .txt {
        position: absolute;
        width: 2.49rem;
        left: 52%;
        transform: translateX(-59%);
        top: .17rem;
      }

      .my-timer {
        position: absolute;
        top: .4rem;
        width: 100%;
        box-sizing: border-box;
        padding-left: .24rem;

        img {
          position: absolute;
          right: .2rem;
          cursor: pointer;
        }
      }
    }
  }
</style>